import { useState } from "react";
import { ClipLoader } from "react-spinners";

type Props = {
  postImage: (file: File) => void;
  setImageURL: (url: string) => void;
};

function UserImageUpload(props: Props) {
  const [fileObj, setFileObj] = useState<string>("");
  const [status, setStatus] = useState<string>("available");

  const handleImageFile = async (file: File) => {
    setFileObj(URL.createObjectURL(file));
    props.postImage(file);
    props.setImageURL(fileObj)
  };
  // useEffect(() => {
  //   const revokeURL = () => {
  //     if (fileObj){
  //       URL.revokeObjectURL(fileObj)
  //     }
  //   }
  //   return revokeURL()
  // })

  return (
    <>
      {status === "uploading" ? (
        <div className="flex items-center justify-center w-full h-full">
        <ClipLoader size={30} />
        </div>
      ) : fileObj ? (
        <div className="size-28 rounded-full overflow-hidden">
          <img src={fileObj} className="object-cover min-w-full" />
        </div>
      ) : (
        <>
          <label htmlFor="file" className="flex items-center justify-center size-28 rounded-full border bg-graycolor hover:opacity-60 cursor-pointer">
            <span className="text-sm text-white text-center">
              画像を
              <br />
              登録する
            </span>
          </label>
          <input
            id="file"
            type="file"
            className="hidden"
            multiple={false}
            accept="image/*"
            onChange={(e) => {
              setStatus("uploading");
              if (e.target.files && e.target.files[0]) {
                handleImageFile(e.target.files[0]);
              }
              setStatus("available");
            }}
          />
        </>
      )}
    </>
  );
}

export default UserImageUpload;
